import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.7785 5.23242C22.0798 5.53628 22.0729 6.02215 21.763 6.31764L11.6093 16L21.763 25.6824C22.0729 25.9778 22.0798 26.4637 21.7785 26.7676C21.4771 27.0714 20.9817 27.0782 20.6718 26.7828L10.4471 17.0327C10.307 16.8992 10.1943 16.7392 10.1172 16.562C10.04 16.3845 10 16.1935 10 16C10 15.8065 10.04 15.6155 10.1172 15.438C10.1943 15.2608 10.3066 15.1012 10.4466 14.9677L20.6718 5.21725C20.9817 4.92176 21.4771 4.92855 21.7785 5.23242Z",
		fill: "currentColor"
	})
});
export { SvgChevronLight as ReactComponent };
